import ChangePasswordPage from './change-password-container'

export default ChangePasswordPage
